import React, { useState,useRef,useEffect } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { ArticleBarSearch } from '@gull'
import axios from 'axios'
import swal from "sweetalert2";
// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const LineItemFromBase = (props) =>{
    const t = useTranslate();

    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const [inputScan,setInputScan]=useState('')
    const [disabled,setDisabled]=useState(false) 
    const searchInput = useRef('')

    const [valuePrice,setValuePrice]=useState(0) 
    const [valueQte,setValueQte]=useState(0) 

    useEffect(function () {
        //ici on attribut les infos de l'article "main d'oeuvre" de la base rajouter quoi qu'il arrive lors dela création d'un custom article
        if(props.indexToEdit==1){
            setInputScan(props.allCustomMadeItem[1].name)
            setValuePrice(props.allCustomMadeItem[1].price)
            setValueQte(1)
            setDisabled(true)
        }
    }, [])

    const handleChange = (e,name) =>{
        let newData = [...props.allCustomMadeItem] 
        let lineData = {...props.customMadeItem}

        if(name=='qte'){
            setValueQte(e.target.value.replace(/[^0-9\.]/g, ''))
            lineData.qte = e.target.value.replace(/[^0-9\.]/g, '')
        }else{
            setValuePrice(e.target.value.replace(/[^0-9\.]/g, ''))
            lineData.price = e.target.value.replace(/[^0-9\.]/g, '')
        }
        
        newData.splice(props.indexToEdit,1, {type:'itemBase',...lineData})
        props.setAllCustomMadeItem(newData)
    }
    
    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }

    const addNewItem = async (e,articleid,inputname,articleBar) =>{
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"

        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{  
                let newData = [...props.allCustomMadeItem] 
                if(e){
                    setInputScan(response.data.data.article.name)

                    newData.splice(props.indexToEdit,1, {type:'itemBase',qte:1,...response.data.data.article})
                    props.setAllCustomMadeItem(newData)
                    setValuePrice(response.data.data.article.price)
                    setValueQte(1)
                }else{
                    setInputScan(response.data.data.name)
                    
                    newData.splice(props.indexToEdit,1, {type:'itemBase',qte:1,...response.data.data})
                    props.setAllCustomMadeItem(newData)
                    setValuePrice(response.data.data.price)
                    setValueQte(1)
                }
                setDisabled(true)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setLoadingSearchItem(false)
    }

    const handleDelete = () =>{
        let deletedData = [...props.allCustomMadeItem] 
        deletedData.splice(props.indexToEdit,1)
        
        props.setAllCustomMadeItem(deletedData)
    }

    return (
        <div className={`${(props.indexToEdit%2 == 0) ? 'stripeBg stripePadding px-2 position-relative' : 'stripePadding px-2 position-relative' } mb-3`}>
            <ArticleBarSearch 
                loadingSearchItem={loadingSearchItem}
                loadItems={loadItems}
                listSearchItem={listSearchItem}
                datas={datas}
                setDatas={setDatas}
                valueInput={inputScan}
                setValueInput={setInputScan}
                handleSubmit={addNewItem}
                searchInput={searchInput}
                noBlur={false}
                disabled={disabled}
                setDisabled={setDisabled}

                allCustomMadeItem={props.allCustomMadeItem}
                setAllCustomMadeItem={props.setAllCustomMadeItem}
                indexToEdit={props.indexToEdit}
            />
            {(props.customMadeItem.hasOwnProperty('name')) ?
                <div className='row fw-bold'>
                    <div className='col-6'>{props.customMadeItem.name}</div>
                    <div className='col-2 d-flex align-items-center'>
                        X&nbsp;
                        <input type="text" value={valueQte} className='form-control form-control-sm' onChange={(e)=>handleChange(e,'qte')}/>
                    </div>
                    <div className='col-2'>
                        <input type="text" value={valuePrice} className='form-control form-control-sm' onChange={(e)=>handleChange(e,'price')}/>
                    </div>
                    <div className='col-2'>
                        <input type="text" value={valueQte*valuePrice} className='form-control form-control-sm'  disabled/>
                    </div>
                </div>
            :
                false
            }
            <div className='positionCrossCustomMadeItem' onClick={()=>handleDelete()}>
                <FontAwesomeIcon icon={faTimesCircle} />
            </div>
        </div>
    )
};

export default LineItemFromBase;